import { Link } from "@remix-run/react";
import { Link as ScrollLink } from "react-scroll";

import type { ImageType } from "~/components/common/images";
import Image from "~/components/common/images";
import KonnectButton from "~/components/common/KonnectButton/KonnectButton";
import { Logo } from "~/components/common/Logo/Logo";
import { CONTACT_EMAIL } from "~/Config/config";

import { SCROLL_OFFSET } from "../Header/Header";

export interface FooterProps {
  image?: ImageType;
  backgroundImage?: ImageType;
  title: string;
  description: string;
  link?: {
    title: string;
    url: string;
  };
  isHome?: boolean;
}

const Footer = ({
  title,
  description,
  backgroundImage,
  link,
  isHome = false,
}: FooterProps) => (
  <footer className="section-padding-x relative mt-[120px] bg-purple bg-gradient-to-b lg:mt-[60px]">
    {backgroundImage && isHome && (
      <div className="absolute left-0 top-0 z-0 size-full">
        <Image
          image={backgroundImage}
          className="size-full object-cover"
          alt=""
        />
      </div>
    )}
    {isHome && (
      <aside className="relative z-[1] flex flex-col-reverse justify-between lg:flex-row">
        <div className="mt-16 w-full pb-[100px] md:pb-[150px] lg:max-w-[600px] lg:pt-[120px] 2xl:w-2/5">
          <h3 className="h2 mb-[25px] font-semibold text-white">{title}</h3>
          <p className="text-md font-medium text-white">{description}</p>
          {link?.url && (
            <ScrollLink
              to={link.url || "PricingSection"}
              offset={-SCROLL_OFFSET}
              duration={500}
              smooth={true}
            >
              <KonnectButton
                bgColor="white"
                hoverBgColor="purple/80"
                textColor="charcoal"
                hoverTextColor="white"
                icon
                text={link.title}
                className="mt-[45px]"
              />
            </ScrollLink>
          )}
        </div>
        <div className="ml-auto size-full max-w-[300px] lg:w-1/2 lg:max-w-[600px]"></div>
      </aside>
    )}
    <div
      className={`relative z-[1] flex items-center justify-between pb-[14px] ${
        !isHome && `pt-[30px]`
      }`}
    >
      <Link to="/">
        <Logo color="white" className="h-auto w-[140px]" />
      </Link>
      <a href={`mailto:${CONTACT_EMAIL}`}>
        <KonnectButton
          text={"Contact us"}
          textColor="charcoal"
          hoverTextColor="white"
          bgColor="white"
          hoverBgColor="purple/80"
        />
      </a>
    </div>
    <div className="relative z-[1] flex flex-col justify-between gap-12 py-[35px] md:flex-row md:items-end md:gap-0 md:py-[60px]">
      <div className="hidden md:block">
        <h4 className="mb-[10px] text-xs uppercase text-white">Contact</h4>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="text-sm text-white transition hover:text-teal"
        >
          {CONTACT_EMAIL}
        </a>
      </div>
      <div className="flex flex-col-reverse gap-4 text-sm text-white/75 sm:flex-row sm:gap-12">
        <span>© Konnect 2023 | All Rights Reserved</span>
        <a href="/terms-conditions" className="transition hover:text-teal">
          Terms & Conditions
        </a>
        <a href="/privacy-policy" className="transition hover:text-teal">
          Privacy policy
        </a>
      </div>
    </div>
  </footer>
);

export default Footer;
